import moment from "moment-timezone";

import { MobiledocContent } from "app/Mobiledoc";
import request from "app/http";

const BLOG_API_URL = "/apiv2/user/inbox-blog-posts";

export interface Post {
    title: string;
    mobiledoc?: MobiledocContent;
    full_title: string;
    guid: string;
    link: string;
    pub_date: string;
    viewed: boolean;
}

interface BlogResponse {
    posts: { [uuid: string]: Post };
    unreadCount: number;
}

export interface Blog {
    posts: Post[];
    unreadCount: number;
}

export async function fetchBlog(): Promise<Blog> {
    const blog: BlogResponse = await request(BLOG_API_URL);

    const posts = Object.values(blog.posts).sort((a: Post, b: Post) => {
        return moment(a.pub_date).isAfter(moment(b.pub_date)) ? -1 : 1;
    });

    return { posts, unreadCount: blog.unreadCount };
}

export function markViewed(post: Post): void {
    // uuid travels in the body: real feed guids are full URLs and do not
    // survive as path parameters. Deliberately silent on failure: a lost
    // read mark self-heals on the next fetch; console only.
    request({
        url: BLOG_API_URL,
        method: "PATCH",
        data: { uuid: post.guid, viewed: true }
    }).catch(e => console.error("markViewed failed", e));
}
